import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Later classes win over earlier ones even when both target the same property,
// which is what lets a caller pass className to override a variant's default.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
